import React from 'react';
import { MessageSquare, Video, FileText, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const activities = [
  {
    id: 1,
    type: 'message',
    title: 'New Message',
    description: 'Sarah shared feedback on the technical proposal',
    time: '10 minutes ago',
    icon: MessageSquare,
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600',
  },
  {
    id: 2,
    type: 'meeting',
    title: 'Upcoming Meeting',
    description: 'Contract Review Meeting at 2:00 PM',
    time: 'In 1 hour',
    icon: Video,
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600',
  },
  {
    id: 3,
    type: 'task',
    title: 'Task Due',
    description: 'Security Assessment documentation deadline',
    time: 'Tomorrow',
    icon: FileText,
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
  },
];

export function CollaborationPanel() {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/marketplace/collaboration', { 
      state: { activeTab: 'collaboration' },
      replace: true 
    });
  };

  const handleActivityClick = (activity: typeof activities[0]) => {
    switch (activity.type) {
      case 'message':
        navigate('/marketplace/collaboration?tab=messages');
        break;
      case 'meeting':
        navigate('/marketplace/collaboration?tab=meetings');
        break;
      case 'task':
        navigate('/marketplace/collaboration?tab=tasks');
        break;
    }
  };

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Collaboration</h2>
        <button 
          onClick={handleViewAll}
          className="text-sm font-medium text-purple-600 hover:text-purple-500"
        >
          View All
        </button>
      </div>
      <div className="mt-6 space-y-4">
        {activities.map((activity) => {
          const Icon = activity.icon;
          return (
            <button
              key={activity.id}
              onClick={() => handleActivityClick(activity)}
              className="w-full text-left"
            >
              <div className="flex items-center justify-between rounded-lg border border-gray-100 bg-white p-4 shadow-sm transition-colors hover:bg-gray-50">
                <div className="flex items-center space-x-4">
                  <div className={`rounded-lg ${activity.iconBg} p-3`}>
                    <Icon className={`h-5 w-5 ${activity.iconColor}`} />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">{activity. title}</h3>
                    <p className="text-sm text-gray-500">{activity.description}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="flex items-center text-sm text-gray-500">
                    <Clock className="mr-1.5 h-4 w-4 text-gray-400" />
                    {activity.time}
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}